import {IEntity} from './entity'
import { mapDateFromApi } from 'src/core/utils'
import { mapPaginationFromApi } from './paginated'
import { IDocument } from './document'


export interface IProduct extends IEntity {
    created_at: Date;
    created_by?: string;
    name: string;
    product_type: string;
    image_cover_url?: string;
    category_principale?: string;
    category_produit?: string;
    category_actu?: string;
    description?: string;
    description_short?: string;
    description_compliance?: string;
    tag?: string;
    custom?: string;
    documents?: IDocument[]
}

export interface IProductType{
    value: string;
    label: string;
}


export enum ProdcutType {
    COLLAR_KI_KO = 'COLLAR_KI_KO',
    AUTOCALL_RENDEMENT = 'AUTOCALL_RENDEMENT',
    WEDDING_CAKE_OPTIONS = 'WEDDING_CAKE_OPTIONS',
    TUNNEL_ASYMETRIQUE = 'TUNNEL_ASYMETRIQUE',
    TERME_PARTICIPATIF = 'TERME_PARTICIPATIF',
    TERME_ASYMETRIQUE = 'TERME_ASYMETRIQUE',
    TERME_ASYMETRIQUE_DESACTIVANT = 'TERME_ASYMETRIQUE_DESACTIVANT',
    TERME_ACCUMULATEUR_KO = 'TERME_ACCUMULATEUR_KO',
    TERME_SEC = 'TERME_SEC',
    TARF = 'TARF',
    WEDDING_CAKE_ACCUMULATEUR = 'WEDDING_CAKE_ACCUMULATEUR',
    SWAP = 'SWAP',
    CAP = 'CAP',
    COLLAR = 'COLLAR',
    SWAP_KO = 'SWAP_KO',
    CAP_KO = 'CAP_KO',
    COLLAR_KO = 'COLLAR_KO',
    DIY_PLACEMENT = 'DIY_PLACEMENT',
    DIY_CHANGE = 'DIY_CHANGE'
}

export const mapProductFromApi = (apiProduct: any): IProduct => ({
    ...apiProduct,
    created_at: mapDateFromApi(apiProduct.created_at),
});
  
export const mapProductPaginationFromApi = mapPaginationFromApi<IProduct>(mapProductFromApi)

export const categoryToQP = {
    "produits-structures-complexes": "qp_warning_structure_complexe",
    "obligations-et-titres-de-creance": "qp_warning_oblig_titres_creance",
    "change-ferme": "qp_warning_change_ferme",
    "change-conditionnel": "qp_warning_change_conditionnel",
    "taux-ferme": "qp_warning_taux_ferme",
    "taux-conditionnel": "qp_warning_taux_conditionnel"
}


// WEBPACK FOOTER //
// ./src/type/product.ts